const pre=`https://www.demobackendportal.nigergames.com/`;
const getGamesApi=`${pre}sendGames`;
export {getGamesApi};
